<template>
    <div> 
        <v-dialog
            v-if="property.floorplans.length > 0"
            v-model="floorplanDialog"
            width="800"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" elevation="0" :small="mobile"
                    class="mb-3"
                    v-on="on" v-bind="attrs">
                    Floor plan
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{ property.floorplans.length > 1 ? "Floor plans" : "Floor plan" }}
                </v-card-title>

                <v-card-text class="pt-3">
                    <v-carousel :show-arrows="false" :hide-delimiters="property.floorplans.length < 2" height="auto" :style="property.floorplans.length < 2 ? '' : 'padding-bottom: 50px;'">
                        <v-carousel-item
                        v-for="(item, i) in property.floorplans"
                        :key="i"
                        >
                            <v-img :src="item.url" contain height="auto"></v-img>
                        </v-carousel-item>
                    </v-carousel>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="floorplanDialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-if="property.energyEfficiencyRatingCurrent || property.environmentalImpactRatingCurrent"
            v-model="EPCDialog"
            width="500"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" elevation="0" :small="mobile"
                    v-on="on" v-bind="attrs" class="mb-3">
                    EPC
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    EPC Ratings
                </v-card-title>

                <v-card-text class="pt-3">
                    <v-carousel :height="bothEPC ? 437 : 387" 
                        :hide-delimiters="!bothEPC"
                        :show-arrows="false">
                        <v-carousel-item v-if="property.energyEfficiencyRatingCurrent || property.energyEfficiencyRatingPotential">
                            <EPCChart kind="energy" 
                                :current="property.energyEfficiencyRatingCurrent" 
                                :potential="property.energyEfficiencyRatingPotential">
                            </EPCChart>
                        </v-carousel-item>

                        <v-carousel-item v-if="property.environmentalImpactRatingCurrent || property.environmentalImpactRatingPotential">
                            <EPCChart kind="co2" 
                                :current="property.environmentalImpactRatingCurrent" 
                                :potential="property.environmentalImpactRatingPotential">
                            </EPCChart>
                        </v-carousel-item>
                    </v-carousel>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="EPCDialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="property.kid && property.kid.length">
            <div v-for="kid, index in property.kid" key="kid.url">
                <v-btn color="primary" elevation="0" :small="mobile" class="mb-3" @click="downloadKid(kid)">
                    Key Information Document {{ property.kid.length > 1 ? `(${index+1})` : '' }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, computed } from '@vue/composition-api'
    import EPCChart from './EPCChart.vue';

    export default defineComponent({
        name: 'Downloads',
        components: { EPCChart },
        props: {
            mobile: {
                required: false
            },
            property: {
                type: Object,
                required: true
            }
        },
        setup(props, context) {
            const floorplanDialog = ref(false);
            const EPCDialog = ref(false);

            const bothEPC = computed(() => {
                return (
                        props.property.energyEfficiencyRatingCurrent || 
                        props.property.energyEfficiencyRatingPotential
                    ) && (
                        props.property.environmentalImpactRatingCurrent || 
                        props.property.environmentalImpactRatingPotential
                    );
            });

            const downloadKid = (kid) => {
                window.open(kid.url, '_blank', 'noreferrer');
            }

            return {
                floorplanDialog,
                EPCDialog,
                bothEPC,
                downloadKid
            }
        },
    })
</script>